import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';
import mask from 'jquery-mask-plugin';

export default function budgetForm(){
    class BudgetDelete extends AjaxClass {
        successFunction(html) {
            if ($('[productList]').get().length == 0) {
                window.location = $("#routeCurrent").val();
            }
        }

        beforeSendFunction() {
        };
    }

    class BudgetDeleteAll extends AjaxClass {
        successFunction(html) {
            window.location = $("#routeCurrent").val();
        }

        beforeSendFunction() {
        };
    }

    $("[maskPhone]").mask('(00) 00000.00.00');
    $(document).on('click', '[delete]', function(e) {
        e.preventDefault();
        let productId = $(this).attr('productId');
        let url = $("#routeBudgetDelete").val();
        let budget = new BudgetDelete(null, 'POST', url, 'html', 'productId=' + productId);
        budget.sendNoRecaptcha();
        $("#item_" + productId).remove();
    });
    $(document).on('click', '[deleteAll]', function(e) {
        e.preventDefault();
        let url = $("#routeBudgetDeleteAll").val();
        let budget = new BudgetDeleteAll(null, 'POST', url, 'html', '');
        $("[productList]").remove();
        budget.sendNoRecaptcha();
    });

    $("[budget-form]").on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")
        let form = $(this);
        let fields = form.serializeArray();
        let city = {
            name: "city",
            value: $("#budget-city").val(),
        };
        let state = {
            name: "state",
            value: $("#budget-state").val(),
        };
        let sector = {
            name: "sector",
            value: $("#budget-sector").val(),
        };

        fields.splice(fields.length - 1, 0, city);
        fields.splice(fields.length - 1, 0, state);
        fields.splice(fields.length - 1, 0, sector);  
        
        let validation = new FormValidate(fields, 1, form.attr('id'));
        const modalSuccess = document.getElementById('success-message-forms');
        const modalSuccessDescription = document.querySelector('#success-message-forms .description');
        const modalError = document.getElementById('error-message-forms');
        const modalDescription = document.querySelector('#error-message-forms .description');      

        validation.validateAll(fields);
        let error = validation.hasError();
        
        MessageHandler.removeAllFormFailMessages()
        let terms = $("#" + form.attr('id')).find("input[type='checkbox']");
        let termsChecked = terms.prop('checked') == true;
        if (!error && !city.value){
            error = true
            const id = 'budget-error-city';
            MessageHandler.showFailMessage(id, false);
            return false;
        }
        if (!error && !state.value){
            error = true
            const id = 'budget-error-state';
            MessageHandler.showFailMessage(id, false);
            return false;
        }
        if (!error && !sector.value){
            error = true
            const id = 'budget-error-sector';
            MessageHandler.showFailMessage(id, false);
            return false;
        }
        if (!error && !termsChecked){
            error = true
            const id = terms.attr('idError');
            MessageHandler.showFailMessage(id, false);
            return false;
        }

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(errorMessageId, false);
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            
            class Budget extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $(".show--error").removeClass('show--error');
                        let etapa2 = document.querySelector('.etapa-2')
                        let etapa3 = document.querySelector('.etapa-3')
                        etapa2.classList.toggle('d-none');
                        etapa2.setAttribute('tabindex', -1);

                        etapa3.classList.toggle('d-none');
                        etapa3.setAttribute('tabindex', 1);

                        // hide offcanvas-header
                        let header = document.querySelector('#sidebar-orcamento .offcanvas-header');
                        header.style.opacity = '0'
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("[budget-form]").removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("[budget-form]").removeAttr('disabled');
                };
            }
            let ajax = new Budget(form, type, url, dataType, form.serialize());
            ajax.send();
        }

        return false;
    });
}
